/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';
import {Envelope} from '@app/modules/operations-api/models/envelope';
import {JobView} from '@models/JobView';
import {PlacesCountry} from '@app/modules/operations-api/models/places-country';

@Injectable({
  providedIn: 'root',
})
class CountryService extends __BaseService {
  static readonly CountryGetAllPath = '/api/country';
  static readonly CountryGetPath = '/api/country/{id}';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @return OK
   */
  CountryGetAllResponse(): __Observable<__StrictHttpResponse<Envelope<PlacesCountry[]>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/country`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Envelope<PlacesCountry[]>>;
      })
    );
  }
  /**
   * @return OK
   */
  CountryGetAll(): __Observable<Envelope<PlacesCountry[]>> {
    return this.CountryGetAllResponse().pipe(
      __map(_r => _r.body as Envelope<PlacesCountry[]>)
    );
  }

  /**
   * @param id undefined
   * @return OK
   */
  CountryGetResponse(id: number): __Observable<__StrictHttpResponse<Envelope<PlacesCountry>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/country/${encodeURIComponent(id)}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Envelope<PlacesCountry>>;
      })
    );
  }
  /**
   * @param id undefined
   * @return OK
   */
  CountryGet(id: number): __Observable<Envelope<PlacesCountry>> {
    return this.CountryGetResponse(id).pipe(
      __map(_r => _r.body as Envelope<PlacesCountry>)
    );
  }
}

module CountryService {
}

export { CountryService }
